import ddisTable from './_table.js'
import template from './index.pug'

export default Vue.extend({
  template: template(),
  components: {
    ddisTable
  },
  data() {
    return {
      ddis: [],
      meta: {}
    }
  },
  created() {
    this.$setPageTitle(this.$t('ddis.index.title'))
    this.$setBreadcrumbs([
      {label: this.$t('breadcrumbs.ddis.index'), route: {}}
    ])
  },
  methods: {
    loadDdis(queryOptions = {}) {
      API.ddis.index(queryOptions).then(({data, meta}) => {
        this.ddis = data
        this.meta = meta
      })
    }
  }
})
